import Typography from '@components/v2/ui/Typography/Typography';
import { Box } from '@mui/material';
import LangEnum from '../../../../lang/LangEnum';
import HighlightsMenuSection from '../../../../modules/highlights/HighlightsMenuSection';
import TeamSelectModal from '../../../../modules/login/components/TeamSelectModal/TeamSelectModal';
import UserSelectModal from '../../../../modules/login/components/UserSelectModal/UserSelectModal';
import OfflineModal from '../../../../modules/offline/components/OfflineModal/OfflineModal';
import { useTranslation } from '../../../../modules/translation/TranslationContext';
import UserMenu from './UserMenu';
import TeamSelector from './components/TeamSelector/TeamSelector';
import UserMenuButton from './components/UserMenuButton/UserMenuButton';
import { useOfflineMenuItem } from './hooks/useOfflineMenuItem';
import { useUserMenu } from './hooks/useUserMenu/useUserMenu';

const UserMenuTrigger = () => {
  const {
    buttonProps,
    mainMenuProps,
    teamMenuProps,
    teamItemProps,
    userItemProps,
    userSelectModalProps,
    adminTeamModalProps,
  } = useUserMenu();

  const { itemProps: offlineItemProps, openOfflineModal, offlineModalProps } = useOfflineMenuItem();

  const { translate } = useTranslation();

  const adminTitle = (
    <Typography variant="h6" component="h2" noWrap>
      {translate(LangEnum.TEAM_MODAL_SWITCH_USER_TITLE)}{' '}
      <Box component="span" sx={{ color: 'text.secondary' }}>
        {translate(LangEnum.GLOBAL_TECEO_ADMIN)}
      </Box>
    </Typography>
  );

  return (
    <>
      <UserMenuButton {...buttonProps} />
      <UserMenu
        {...mainMenuProps}
        teamItemProps={teamItemProps}
        userItemProps={userItemProps}
        slots={{ highlightsSection: <HighlightsMenuSection /> }}
        offlineItemProps={{ ...offlineItemProps, onClick: openOfflineModal }}
      />
      <TeamSelector {...teamMenuProps} />
      <UserSelectModal {...userSelectModalProps} title={adminTitle} />
      <TeamSelectModal {...adminTeamModalProps} title={adminTitle} />
      <OfflineModal {...offlineModalProps} />
    </>
  );
};

export default UserMenuTrigger;
